import {get, post} from '~/utils/request';

export function getMobileVerifyCode(data) {
  return post('/MyCenter/GetMobileCode', data);
}

export function changeMobile(data) {
  return post('/MyCenter/ChangeMobile', data);
}

export function getEmailVerifyCode(data) {
  return post('/MyCenter/GetEmailCode', data);
}

export function changeEmail(data) {
  return post('/MyCenter/ChangeEmail', data);
}

export function hasMeRecord(data) {
  return get('/MeData/HasMeRecord', data);
}

export function getMyHrService(data) {
  return get('/MyCenter/MyHrService', data);
}

export function getUserInfoChat(data) {
  return post('/User/GetUserInfoChat', data);
}